






































import Vue from 'vue';
import { getAssignment, addSubmission, Assignment } from '@/repository/assignment';

export default Vue.extend({
  props: [
    'id',
  ],
  data: () => ({
    files: new Array<File>(),
    assignment: {} as Assignment,
    name: '',
    isLoading: false,
    isError: false,
  }),
  methods: {
    openInput() {
      (this.$refs.files as HTMLElement).click();
    },
    pushFile() {
      const f = (this.$refs.files as HTMLInputElement).files as FileList;
      this.files.push(...f);
    },
    getFileIcon(file: File): string {
      const type = file.type.split('/')[0];
      if (type === 'audio') return 'file-music';
      if (type === 'text') return 'file-document';
      if (type === 'image' || type === 'video') return `file-${type}`;
      return 'file';
    },
    removeItem(item: File) {
      this.files.splice(this.files.indexOf(item), 1);
    },
    updateAss() {
      getAssignment(this.id).then((result) => {
        this.assignment = result;
      }).catch((err) => {
        if (err.message === '404') {
          this.$router.replace('/404');
          return;
        }
        console.error(`Error fetch assignment ${this.id}: `, err);
      });
    },
    submit() {
      this.isLoading = true;
      addSubmission(this.assignment, this.name, this.files)
        .then(() => {
          this.$router.push('/submit-done');
          this.isLoading = false;
        }).catch((err) => {
          console.error('Submit error', err);
          this.isError = true;
        });
    },
  },
  watch: {
    id: {
      immediate: true,
      handler() {
        this.updateAss();
      },
    },
  },
});
